// @flow

import {Tag, ContentGroupItem} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

const VALID_TAB_PREFS = [
  'ui',
  'account-type',
  'dispute-category',
  'country',
  'push-pull-preference',
  'issuing-capture-type',
  'webhook-or-success-url',
  'html-or-css',
  'react-hooks',
  'payments',
  'read-migration',
  'intent',
  'client',
  'terminal-ios-sdk-installation-method',
  'card-or-payment-element',
  'cli-curl',
  'ach-or-sepa',
  'issuing-currency',
  'destination-or-on-behalf-of',
  'migration-samples',
  'web-migration',
  'charges-cards-migration',
  'elements-or-checkout',
  'react',
  'integration',
  'destination-or-direct',
  'platform',
  'kotlin',
  'uikit-swiftui',
  'bt-region-tabs',
  'business-type',
  'evidence-for',
  'dashboard-or-api',
  'web-tech',
  'terminal-sdk-platform',
  'html-or-react',
  'lang',
  'reader',
  'dash-or-api',
  'irish-non-irish',
  'public-private',
  'nameserver-provider', // Used for Checkout custom domains docs
  'verify-with-terminal-or-web',
  'numbers-or-method-or-token',
  'created-products', // Used for Orders
];

export const TabGroup: MarkdocTagRegistration = {
  tag: 'tabs',
  component: 'TabGroupMarkdocShim',
  attributes: {
    pref: {
      type: String,
      required: false,
      description:
        'The name of the pref which will control the selected tab within the tab group. This can be used to synchronize several tabs within a document.',
      matches: VALID_TAB_PREFS,
    },
    label: {
      type: String,
      required: false,
      description:
        "A label describing the content displayed within the tab group. For drop-down selectors this is displayed, otherwise it's just used as an aria-label.",
      localizable: true,
    },
    selector: {
      type: String,
      required: false,
      defaultValue: 'tabs',
      description:
        'The selector to display above the tab group. Normally this is a row of tabs, but it can also be a drop-down or disabled entirely.',
    },
    defaultValue: {
      type: String,
      required: false,
      description:
        'The tab value to default to for UncontrolledContentGroups or a pref value has not been set yet for a ControlledContentGroup.',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    const items = ContentGroupItem.fromMarkdocTags(children).map((item) => ({
      ...item,
      /**
       * ContentGroupItem does not have access to config, so we add info here to allow the value
       * to be set from context.
       */
      info: item.content?.attributes.info,
    }));
    return new Tag(this.tag, {...attributes, items}, children);
  },
};
